import script from "./linkedInSinglePostViever.vue?vue&type=script&setup=true&lang=js"
export * from "./linkedInSinglePostViever.vue?vue&type=script&setup=true&lang=js"

import "./linkedInSinglePostViever.vue?vue&type=style&index=0&id=8f6d8dd0&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f6d8dd0"]])

export default __exports__